import type { SchoolTestSimilarWorksheet, WorksheetAssignee } from '@mathflat/domain/Worksheet'

export class WorksheetBySchoolTest {
  id: number
  sidoName: string
  sigunguName: string | null
  schoolName: string
  year: number
  title: string
  chapter: string
  assignedStudentWorksheetList: WorksheetAssignee[] = []

  constructor(data: SchoolTestSimilarWorksheet) {
    this.id = data.id
    this.sidoName = data.region.sidoName
    this.sigunguName = data.region.sigunguName
    this.schoolName = data.school.name
    this.year = data.year
    this.title = data.title
    this.chapter = data.chapter
    this.assignedStudentWorksheetList = data.assignList
  }
}
